















































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';
import _ from 'lodash';
// @ts-ignore
import Swatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.min.css';

import Price from './components/price.vue';
import PriceExtend from './components/price_extend.vue';
import TimeSaleSetting from './components/time_sale_setting.vue';

@Component({
  components: {
    Swatches,
    Price,
    PriceExtend,
    TimeSaleSetting,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  mingroundid = 0;

  maxgroundid = 0;

  color = '#19be6b';

  loading = false;

  grounds = [];

  groundarr: any[] = [];

  priceSettings: any[] = [];

  formData1: { [t: string]: any } = {};

  defaultPriceColor = '#fff';

  defaultGroundPrice = 0;

  stadiumClockStart = 0;

  stadiumClockEnd = 0;

  async mounted() {
    this.spinLoading = true;

    this.loading = true;
    this.loadGrounds();
    const res1 = await this.$store.dispatch('stadium/getStadium', {
      stadium_id: this.stadiumId,
    });
    if (res1 && res1.Message && res1.Data) {
      this.defaultGroundPrice = res1.Data.stadium_info.default_ground_price / 100;
      this.stadiumClockStart = res1.Data.stadium_info.business_clock_start;
      this.stadiumClockEnd = res1.Data.stadium_info.business_clock_end;
    }

    const groundidarr: number[] = [];

    const res0 = await this.$store.dispatch('stadium/getStadiumGrounds', {
      stadium_id: this.stadiumId,
    });
    if (res0 && res0.Message && res0.Data) {
      this.groundarr = res0.Data;
      for (const ground of this.groundarr) {
        groundidarr.push(ground.id);
      }
    }

    // 场馆id的最小值
    this.mingroundid = _.min(groundidarr) as number;
    // 场馆id的最大值
    this.maxgroundid = _.max(groundidarr) as number;

    // 价格设置
    const res = await this.$store.dispatch('stadium/getStadiumPriceSetting', {
      stadium_id: this.stadiumId,
    });

    interface PriceItem {
      color: string;
      price: number;
      ground_id_from: number;
      ground_id_to: number;
      hour_from: number;
      hour_to: number;
      stadium_id: number;
      type: number;
      week_from: number;
      week_to: number;
      status: number;
    }

    const normalarr: PriceItem[] = [];

    const specialarr: PriceItem[] = [];

    if (res && res.Data && res.Data.length > 0) {
      for (const obj of res.Data) {
        obj.status = 1;
        obj.price /= 100;
        if (parseInt(obj.type, 10) === 1) {
          // 场馆时间
          normalarr.push(obj);
        } else {
          // 羽约时间
          specialarr.push(obj);
        }
      }
      this.priceSettings = res.Data.sort((a: any, b: any) => b.id - a.id);
    } else {
      // 场馆时间
      normalarr.push(
        {
          color: '#fff',
          price: this.defaultGroundPrice,
          ground_id_from: this.mingroundid,
          ground_id_to: this.maxgroundid,
          hour_from: this.stadiumClockStart,
          hour_to: this.stadiumClockEnd,
          stadium_id: Number(this.stadiumId),
          type: 1,
          week_from: 1,
          week_to: 5,
          status: 1,
        },
        {
          color: '#fff',
          price: this.defaultGroundPrice,
          ground_id_from: this.mingroundid,
          ground_id_to: this.maxgroundid,
          hour_from: this.stadiumClockStart,
          hour_to: this.stadiumClockEnd,
          stadium_id: Number(this.stadiumId),
          type: 1,
          week_from: 6,
          week_to: 0,
          status: 1,
        },
      );
      // 羽约时间
      specialarr.push(
        {
          color: '#fff',
          price: this.defaultGroundPrice,
          ground_id_from: this.mingroundid,
          ground_id_to: this.maxgroundid,
          hour_from: 0,
          hour_to: this.stadiumClockStart,
          stadium_id: Number(this.stadiumId),
          type: 2,
          week_from: 1,
          week_to: 5,
          status: 1,
        },
        {
          color: '#fff',
          price: this.defaultGroundPrice,
          ground_id_from: this.mingroundid,
          ground_id_to: this.maxgroundid,
          hour_from: 0,
          hour_to: this.stadiumClockStart,
          stadium_id: Number(this.stadiumId),
          type: 2,
          week_from: 6,
          week_to: 0,
          status: 1,
        },
        {
          color: '#fff',
          price: this.defaultGroundPrice,
          ground_id_from: this.mingroundid,
          ground_id_to: this.maxgroundid,
          hour_from: this.stadiumClockEnd,
          hour_to: 23,
          stadium_id: Number(this.stadiumId),
          type: 2,
          week_from: 1,
          week_to: 5,
          status: 1,
        },
        {
          color: '#fff',
          price: this.defaultGroundPrice,
          ground_id_from: this.mingroundid,
          ground_id_to: this.maxgroundid,
          hour_from: this.stadiumClockEnd,
          hour_to: 23,
          stadium_id: Number(this.stadiumId),
          type: 2,
          week_from: 6,
          week_to: 0,
          status: 1,
        },
      );
    }

    const normalarr1: any[] = [];
    const specialarr1: any[] = [];

    // console.log(normalarr)

    const obj1 = _.groupBy(
      normalarr,
      (v: any) => `${v.week_from}-${v.week_to}-${v.hour_from}-${v.hour_to}`,
    );

    // console.log(obj1)

    for (const w in obj1) {
      if (_.has(obj1, [w])) {
        const groundids = [];
        for (const obj of _.get(obj1, [w])) {
          groundids.push(obj.ground_id_from);
        }
        const obj21: any = _.get(obj1, [w, 0]);
        normalarr1.push({
          color: obj21.color,
          price: obj21.price,
          ground_ids: groundids,
          hour_from: obj21.hour_from,
          hour_to: obj21.hour_to,
          stadium_id: obj21.stadium_id,
          type: obj21.type,
          week_from: obj21.week_from,
          week_to: obj21.week_to,
          status: obj21.status,
        });
      }
    }
    const obj2 = _.groupBy(
      specialarr,
      (v: any) => `${v.week_from}-${v.week_to}-${v.hour_from}-${v.hour_to}`,
    );
    for (const w in obj2) {
      if (_.has(obj2, [w])) {
        const groundids = [];
        for (const obj of _.get(obj2, [w])) {
          groundids.push(obj.ground_id_from);
        }
        const obj3 = _.get(obj2, [w, 0]);
        specialarr1.push({
          color: obj3.color,
          price: obj3.price,
          ground_ids: groundids,
          hour_from: obj3.hour_from,
          hour_to: obj3.hour_to,
          stadium_id: obj3.stadium_id,
          type: obj3.type,
          week_from: obj3.week_from,
          week_to: obj3.week_to,
          status: obj3.status,
        });
      }
    }

    this.formData = {
      normalarr: normalarr1,
      specialarr: specialarr1,
      groundarr: this.groundarr,
      default_price_color: this.defaultPriceColor,
      default_ground_price: this.defaultGroundPrice,
      stadium_clock_start: this.stadiumClockStart,
      stadium_clock_end: this.stadiumClockEnd,
    };

    this.loading = false;
    this.spinLoading = false;
  }

  addPriceItem(type: number) {
    if (type === 1) {
      this.formData.normalarr.push({
        color: '#fff',
        price: 0,
        ground_id_from: this.mingroundid,
        ground_id_to: this.maxgroundid,
        hour_from: 0,
        hour_to: 0,
        stadium_id: Number(this.stadiumId),
        type: 1,
        week_from: 0,
        week_to: 0,
        status: 1,
      });
    } else {
      this.formData.specialarr.push({
        color: '#fff',
        price: 0,
        ground_id_from: this.mingroundid,
        ground_id_to: this.maxgroundid,
        hour_from: 0,
        hour_to: 0,
        stadium_id: Number(this.stadiumId),
        type: 2,
        week_from: 0,
        week_to: 0,
        status: 1,
      });
    }
  }

  removePriceItem(type: number, index: number) {
    if (type === 1) {
      this.formData.normalarr[index].status = 0;

      this.formData.normalarr = _.filter(
        this.formData.normalarr,
        (o: any) => o.status,
      );
    } else {
      this.formData.specialarr[index].status = 0;
      this.formData.specialarr = _.filter(
        this.formData.specialarr,
        (o: any) => o.status,
      );
    }
  }

  getPrice(week: number, hour: number, groundId: number): string {
    const data = this.priceSettings;

    for (const obj of data) {
      if (
        week >= obj.week_from
        && week <= obj.week_to
        && hour >= obj.hour_from
        && hour < obj.hour_to
        && groundId >= obj.ground_id_from
        && groundId <= obj.ground_id_to
      ) {
        // 满足条件
        return `<div style="background-color:${obj.color}">${obj.price}</div>`;
      }
      // continue;
    }

    return '';
  }

  getPrice1(week: number, hour: number, groundId: number) {
    const price = this.getPrice(week, hour, groundId);
    if (price) {
      return price;
    }
    return this.formData1.default_ground_price;
  }

  async loadGrounds() {
    const res = await this.$store.dispatch('stadium/getStadiumGrounds', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.grounds = res.Data;
    }
  }

  async handleSubmit() {
    await this.$store.dispatch(
      'stadium/saveStadium2',
      JSON.stringify({
        id: Number(this.stadiumId),
        stadium_id: Number(this.stadiumId),
        default_ground_price: this.tsMul(this.formData.default_ground_price, 100),
        business_clock_start: this.formData.stadium_clock_start,
        business_clock_end: this.formData.stadium_clock_end,
      }),
    );

    // 保存的时候，要 金额 x 100
    let normalarr = JSON.parse(JSON.stringify(this.formData.normalarr));
    let specialarr = JSON.parse(JSON.stringify(this.formData.specialarr));
    for (const itm of normalarr) {
      itm.price *= 100;
    }

    for (const itm of specialarr) {
      itm.price *= 100;
    }

    normalarr = _.filter(normalarr, (o: any) => o.status);
    specialarr = _.filter(specialarr, (o: any) => o.status);

    const submitData = JSON.stringify(normalarr.concat(specialarr));

    // console.log(submitData)

    const res = await this.$store.dispatch(
      'stadium/saveStadiumPriceSetting',
      submitData,
    );
    // console.log(res);
    if (res && res.Message && res.Message === 'success') {
      this.$message.success('保存成功');
    } else {
      this.$message.error('保存失败');
    }
  }
}
